<div class="navdiv container-fluid wrapper bg-custom">
    <div class="navbar-header clickable" (click)="onNavClick('/')">
      <img 
        src="assets/images/cover/logo.jpg" 
        style="height: 40px; width:40px; border-radius: 100%;">
    </div>
    <div>
      <ul class="navbar-nav me-auto mb-lg-0 custom-ul">
        <li class="nav-item">
          <div class="nav-link clickable" aria-current="page" (click)="onNavClick('/menu')" href="/menu">{{ 'nav.menu' | translate }}</div>
        </li>
        <li class="nav-item">
          <a class="nav-link clickable" aria-current="page" (click)="onNavClick('/contact')"> {{ 'nav.contact' | translate }}</a>
        </li>
      </ul>
    </div>
    <app-lang-picker></app-lang-picker>
</div>

<!-- <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">Navbar</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="#">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Link</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Dropdown
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" href="#">Action</a></li>
              <li><a class="dropdown-item" href="#">Another action</a></li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item" href="#">Something else here</a></li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link disabled">Disabled</a>
          </li>
        </ul>
        <form class="d-flex">
          <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
          <button class="btn btn-outline-success" type="submit">Search</button>
        </form>
      </div>
    </div>
  </nav> -->
